var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vehicles card"},[_c('page-header',{attrs:{"title":"Fleets","breadcrumbText":"Dashboard >> Fleets"}}),_c('fleets-table')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }